// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1icw7","buttons":"RemoveExpirationActionButtons_buttons__34tvU"};